import React from 'react';
import { Dialog, FormGrid, InputIconButton, MoreActionsMenuButton, TabPanel, TabsHeader, useCopyText, useTabsState } from '../../../toolympus/components/primitives';
import { EditItemProps } from '../../../toolympus/api/useNewItem';
import { Attendee } from './typings';
import { FormControlsForFields, MaybeFieldDefinition, TableForFields } from '../../../toolympus/components/schemed';
import { Schema } from '../../../toolympus/hooks/useSchema';
import { useAttendeeRegistrations } from './useAttendeeRegistrations';
import { FileCopyOutlined, SaveOutlined } from '@mui/icons-material';
import { FormSectionPane } from '../../../toolympus/components/primitives/PaneContainer';
import { IconButton } from '@mui/material';

interface Props {
  data: EditItemProps<Attendee>;
  schema: Schema;
  infoSchema: Schema;
  infoFields: MaybeFieldDefinition[];
}

export const AttendeeReviewDialog = (props: Props) => {
  const { data, schema } = props;

  const registrations = useAttendeeRegistrations(data.item?._id || "");

  const copyText = useCopyText();

  const tabs = useTabsState([
    ["profile", "Profile"],
    ["registrations", "Registrations"],
  ])

  return (
    <Dialog
      {...data.dialog}
      maxWidth="md"
      fullWidth
      noFullscreen
      titleActions={<>
        {!!data.hasChanges &&
          <IconButton size="small" color="primary" onClick={() => data.save()}>
            <SaveOutlined />
          </IconButton>}
        <MoreActionsMenuButton
          actions={[
            ["copyid", "Copy ID", () => copyText(data.item?._id || "-")],
          ]}
          />
      </>}
      dialogTitle="Attendee">
      <FormGrid columns="1fr 1fr" noMargin>
        <FormControlsForFields
          disabled
          data={data.item}
          onChange={() => {}}
          schema={schema}
          fields={[
            ["display_name"],
            ["email", { controlProps: { endAdornment: <InputIconButton position="end" action={() => copyText(data.item?.email || "")} icon={<FileCopyOutlined />} />}}],
          ]}
          />
      </FormGrid>

      <TabsHeader state={tabs} />

      <TabPanel state={tabs.forTab("profile")}>
        {!!data.item?.info &&
          <FormSectionPane>
            <FormGrid columns="1fr 1fr" noMargin>
              <FormControlsForFields
                schema={props.infoSchema}
                data={data.item?.info}
                onChange={(o,c) => data.update({ info: { ...o, ...c }})}
                fields={props.infoFields}
                />
            </FormGrid>
          </FormSectionPane>}

      </TabPanel>

      <TabPanel state={tabs.forTab("registrations")}>
        <TableForFields
          data={registrations.data}
          schema={registrations.schema}
          fields={[
            ["title"],
            ["start_datetime", { utcToLocal: true }],
            ["registration_status"],
          ]}
          fieldLinkNewTab
          fieldLink={f => {
            if(f === "title") {
              return r => `/events/${r.event_id}`;
            }
          }}
          />

      </TabPanel>

    </Dialog>
  );
}
